import type { Config } from "$src/core/models/config";
import icons from "$src/flavors/hyview/assets/icons/generated/icons.glyphmap.json";
import logo from "$src/flavors/hyview/assets/images/logo.png";
import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  GA_MEASUREMENT_ID,
} from "$src/flavors/hyview/constants/env";
import THEME, { FONT_RESOURCES } from "$src/flavors/hyview/constants/theme";
import api from "$src/flavors/hyview/services/api";
import cdn from "$src/flavors/hyview/services/cdn";

import appConfig from "./app.config.json";

const config: Config = {
  name: appConfig.name,
  slug: appConfig.slug,
  logo,

  fonts: FONT_RESOURCES,
  icons,
  theme: THEME,

  api,
  cdn,

  intl: {
    defaultLocale: "en-US",
    // EPG times are the Dutch broadcast schedule, identical wherever you watch.
    timeZone: {
      type: "fixed",
      value: "Europe/Amsterdam",
    },
  },

  linking: {
    root: "https://kahi.hystream.io",
    pairing: "https://kahi.hystream.io/pair",
    footer: {
      privacyPolicy: "https://hypersolid.com/media", // TODO: replace with the real URL
      termsOfService: "https://hypersolid.com/media", // TODO: replace with the real URL
      cookiesPolicy: "https://hypersolid.com/media", // TODO: replace with the real URL
      help: "https://hypersolid.com/media", // TODO: replace with the real URL
      about: "https://hypersolid.com/media", // TODO: replace with the real URL
    },
  },

  logging: {
    type: "sentry",
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
  },
  analytics: {
    type: "ga4",
    measurementId: GA_MEASUREMENT_ID,
    enabled: Boolean(GA_MEASUREMENT_ID),
  },

  tvConnect: appConfig.tvConnect,
};

export default config;
